import { Component, type KeyboardEvent } from 'react';
import ReactSelect, {
  CSSObjectWithLabel,
  type OnChangeValue,
  type Props,
} from 'react-select';
import CreatableSelect from 'react-select/creatable';
export { createFilter } from 'react-select';

export type Option = {
  label: string;
  value: string;
};

const components = {
  DropdownIndicator: null,
};

function createOption(label: string): Option {
  return {
    label,
    value: label,
  };
}

const styles = {
  menuPortal: (styles: CSSObjectWithLabel) => ({ ...styles, zIndex: 3000 }),
  input: (styles: CSSObjectWithLabel) => styles,
};

export default function Select<Option, isMulti extends boolean = false>(
  props: Props<Option, isMulti>,
) {
  return (
    <ReactSelect
      className="react-select"
      classNamePrefix="react-select"
      menuPortalTarget={document.body}
      styles={styles}
      {...props}
    />
  );
}

export class CreatableInputOnly extends Component<
  {
    initialValue?: string[];
    handleUpdate?: (path: string, value: Option[]) => void;
    path: string;
    placeholder?: string;
  },
  { inputValue: string; value?: OnChangeValue<Option, true> }
> {
  state = {
    inputValue: '',
    value: [],
  };
  componentDidMount() {
    const { initialValue } = this.props;
    if (this.props.initialValue) {
      this.setState({
        value: initialValue?.map((element) => createOption(element)),
      });
    }
  }

  handleChange = (value: OnChangeValue<Option, true>) => {
    this.setState({ value }, () => {
      this.handleUpdate();
    });
  };
  handleInputChange = (inputValue: string) => {
    this.setState({ inputValue });
  };
  handleUpdate = () => {
    if (this.props.handleUpdate) {
      this.props.handleUpdate(this.props.path, this.state.value);
    }
  };
  handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    const { inputValue, value } = this.state;

    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
      case ',':
        this.setState(
          {
            inputValue: '',
            value: value
              ? [...value, createOption(inputValue)]
              : [createOption(inputValue)],
          },
          () => {
            this.handleUpdate();
          },
        );

        event.preventDefault();
        break;
      default:
    }
  };
  render() {
    const { inputValue, value } = this.state;
    return (
      <CreatableSelect
        components={components}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={this.handleChange}
        onInputChange={this.handleInputChange}
        onKeyDown={this.handleKeyDown}
        placeholder={this.props.placeholder || 'Type value and press enter...'}
        value={value}
        styles={styles}
        {...this.props}
      />
    );
  }
}
